import { rd } from '@passionware/monads';
import { Tag } from 'lucide-react';
import { FilterEnumConfig } from 'v5/patterns/filters/FilterWidget.types';
import { MergeServices } from 'v5/platform/ts/services';
import { WithMetastructureMappingService } from 'v5/services/internal/MetastructureMappingService/MetastructureMappingService';
import { WithResourceTypeService } from 'v5/services/internal/ResourceTypeService/ResourceTypeService';
import { WithResourceService } from 'v5/services/io/ResourceService/ResourceService';
import { WithTagService } from 'v5/services/io/TagsService/TagsService';
import { WithGroupsService } from 'v5/services/io/GroupsService/GroupsService';

export function createProductionTagsFilterConfig(
  services: MergeServices<
    [
      WithMetastructureMappingService,
      WithResourceTypeService,
      WithResourceService,
      WithTagService,
      WithGroupsService
    ]
  >
): FilterEnumConfig<string> {
  const useTagOptions = (query: string) => {
    const tags = services.tagsService.useTags({
      type: 'resource', // we have broken tags functionality - actually productions use resource tags (due to FormBuilder TAGS.jsx issue)
      search: query
    });
    return rd.map(tags, tags =>
      tags.map(tag => ({
        value: tag.tag,
        label: tag.tag
      }))
    );
  };

  const useTagValues = (values: string[]) => {
    return rd.of(values.map(value => ({ value, label: value })));
  };

  return {
    label: 'Tags',
    icon: <Tag />,
    type: 'enum',
    createDefaultValue: () => ({ operator: 'matchAny', value: [] as string[] }),
    options: {
      useValues: useTagValues,
      useOptions: useTagOptions,
      valueType: 'array'
    }
  };
}
